import { PropTypes } from "prop-types";
import { StyledDecisionLink } from "../../../styles/StyledDecisionLink";
import activeLinkIcon from "../../../assets/img/icons/link-active.svg";
import inactiveLinkIcon from "../../../assets/img/icons/link-inactive.svg";
import SaveIcon from "../../../assets/img/icons/save.svg";
import deleteIcon from "../../../assets/img/icons/close.svg";
import Modal from "react-modal";
import { useState } from "react";
import { ConfirmationModal } from "../../ConfirmationModal";
import { addDecisionUrl, deleteDecisionUrl } from "../../../api/decision/decision";
import ModalHeader from "../../ModalHeader/ModalHeader";
import { Button } from "../../Button";
import { StyledModalTextarea } from "../../../styles/StyledModalTextarea";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { StyledModal } from "../../../styles/StyledModal";

export default function DecisionLink({ id, status, url, refetch }) {
	const { axiosPrivate } = useAxiosPrivate();

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
	const [text, setText] = useState("");

	const handleDelete = async () => {
		await deleteDecisionUrl(axiosPrivate, refetch, id);
	};

	const handleUpdate = async () => {
		await addDecisionUrl(axiosPrivate, id, text, () => {
			setModalIsOpen(false);
			refetch();
		});
	};

	if (status !== "ongoing" && !url) {
		return <span></span>;
	}

	return (
		<>
			<StyledDecisionLink>
				<a
					href={url ? url : ""}
					target="_blank"
					rel="noreferrer"
					className={url || status !== "ongoing" ? "inactive" : "active"}
					onClick={(e) => {
						if (!url) {
							e.preventDefault();
							setModalIsOpen(true);
						}
					}}
				>
					<img src={url || status !== "ongoing" ? inactiveLinkIcon : activeLinkIcon} />
					<span>{url || status !== "ongoing" ? "Document link" : "Add link"}</span>
				</a>
				{url && status === "ongoing" && <img src={deleteIcon} onClick={() => setIsConfirmModalOpen(true)} />}
			</StyledDecisionLink>
			<Modal
				isOpen={isConfirmModalOpen}
				onRequestClose={() => setIsConfirmModalOpen(false)}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal handleDelete={handleDelete} closeModal={() => setIsConfirmModalOpen(false)} />
			</Modal>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => setModalIsOpen(false)}
				style={StyledModal}
				appElement={document.getElementById("app")}
				role="urlEdit-modal"
			>
				<ModalHeader onClick={() => setModalIsOpen(false)} data-testid="urlEdit-modalHeader">
					Add document link
				</ModalHeader>
				<StyledModalTextarea size="small">
					<input
						role="urlEdit-textarea"
						data-testid="urlEdit-textarea"
						onChange={(e) => {
							setText(e.target.value);
						}}
						defaultValue={text}
						type="text"
					/>
					<div>
						<Button testid="urlEdit-cancelButton" onClick={() => setModalIsOpen(false)} bg={false} small={true}>
							cancel
						</Button>
						<Button
							icon={SaveIcon}
							testid="urlEdit-submitButton"
							onClick={() => {
								handleUpdate();
							}}
						>
							save changes
						</Button>
					</div>
				</StyledModalTextarea>
			</Modal>
		</>
	);
}

DecisionLink.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	status: PropTypes.string,
	url: PropTypes.string,
	refetch: PropTypes.func,
};
